export const DateFormatPatterns = {
    shortDateWithSlash: 'MM/dd/yyyy',
    shortDateWithDash: 'yyyy-MM-dd',
    fullMonth: 'LLLL',
    fullMonthAndYear: 'LLLL, yyyy',
    lessShortLocalizedDateTime: 'LLL dd, yyyy, hh:mm:ss a',
};
